<script setup>
import { computed, inject } from 'vue'
import EmbeddedLowCodePageRender from '@/components/render/EmbeddedLowCodePageRender.vue'

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
})

const getConfigJson = inject('getConfigJson', () => ({}))
const areaData = computed(() => String(props.config?.staticData || '').trim())
const parentContext = computed(() => (
  typeof getConfigJson === 'function' ? getConfigJson() : {}
))
</script>

<template>
  <EmbeddedLowCodePageRender
    v-if="areaData"
    class="diy-design"
    :area-data="areaData"
    :is-mobile="true"
    :parent-context="parentContext"
  />
</template>

<style scoped>
.diy-design {
  width: 100%;
}
</style>
